import { render, staticRenderFns } from "./ModalAddLibrary.vue?vue&type=template&id=c8c1e412&scoped=true&"
import script from "./ModalAddLibrary.vue?vue&type=script&lang=js&"
export * from "./ModalAddLibrary.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddLibrary.vue?vue&type=style&index=0&id=c8c1e412&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c1e412",
  null
  
)

export default component.exports